export enum Tabs {
  Accounts = 'accounts',
  UserDetails = 'user',
  Solicitations = 'solicitations',
  Transactions = 'transactions',
  Wallets = 'wallets',
}
